<div class="initialized-card">
  <div class="status-row">
    <mat-icon svgIcon="circle_tick" class="status-icon"></mat-icon>
    <span class="status-text fs-16 fw-500">{{'INSTANCE_LIST.INITIALIZED' | transloco}}</span>
  </div>

  <div class="created-row">
    <span class="label fs-12 fw-400">{{'BLUEPRINT_SUMMARY.CREATED' | transloco}}:</span>
    <ng-container *ngIf="!isDateLoading; else loader">
      <span class="value fs-12 fw-400">{{ formattedDate }}</span>
    </ng-container>
    <ng-template #loader>
      <div class="skeleton-loader">
        <ngx-skeleton-loader count="1" appearance="line" [theme]="{ height: '18px', width: '120px' }"></ngx-skeleton-loader>
      </div>
    </ng-template>
    <span class="vertical-indicator"></span>
    <mat-icon class="account-circle" svgIcon="account_circle_filled" matTooltipClass="tooltip-inner right" [matTooltip]="createdBy" [matTooltipPosition]="'right'"></mat-icon>
  </div>
</div>